// extracted by mini-css-extract-plugin
module.exports = {"content":"Popup_content__gE_Gc"};